import { render, staticRenderFns } from "./readForm.vue?vue&type=template&id=a525821a&"
import script from "./readForm.vue?vue&type=script&lang=js&"
export * from "./readForm.vue?vue&type=script&lang=js&"
import style0 from "./readForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports